import { JobsConfigurationCommand } from "modules/system/sections/plt/field-management/rings/rollout-package/configure/jobs/dtos";
import { useEffect } from "react";

import {
  OptionsSelectField,
  OptionsSelectFieldProps,
  useFieldContext
} from "@bps/fluent-ui";
import { HttpError } from "@bps/http-client";
import { Validator } from "@bps/validator";
import { CustomRJSFSchema } from "@libs/api/gateways/field/field-ops-gateway.dtos";

export const commandFormValidator = new Validator<JobsConfigurationCommand>();

interface CommandNameInputProps
  extends Omit<OptionsSelectFieldProps, "name" | "options"> {
  values: CustomRJSFSchema[];
  isLoading: boolean;
  error?: HttpError;
}

export const CommandNameInput: React.FC<CommandNameInputProps> = ({
  values,
  isLoading,
  ...props
}) => {
  const commandOptions =
    values?.map(x => {
      return {
        key: x.title!,
        text: x.title!
      };
    }) ?? [];

  const { value: commandNameValue } = useFieldContext<string>("commandName");
  const {
    value: messageTypeValue,
    setFieldValue: setMessageTypeFieldValue
  } = useFieldContext<string>("messageType");

  const {
    value: messageValue,
    setFieldValue: setMessageFieldValue
  } = useFieldContext<string>("message");

  useEffect(() => {
    if (!!commandNameValue) {
      const schema = values.find(x => x.title === commandNameValue);
      const messageType = schema?.["x-messageType"];

      if (!!messageType && messageType !== messageTypeValue) {
        setMessageTypeFieldValue(messageType);

        if (!!messageValue) {
          // Clear out the message body too
          setMessageFieldValue("{}");
        }
      }
    }
  }, [
    commandNameValue,
    messageValue,
    messageTypeValue,
    values,
    setMessageFieldValue,
    setMessageTypeFieldValue
  ]);

  return (
    <OptionsSelectField
      required
      loading={isLoading}
      placeholder="Select command..."
      name="commandName"
      label="Command Name"
      options={commandOptions}
      {...props}
    />
  );
};
